// Konstanten für die drei Anlagen
export const ASSETS = {
  PRODUKTIONSLINIE: {
    id: 'produktionslinie_alpha',
    name: 'ProduktionsLinie Alpha',
    type: 'manufacturing',
    components: [
      { id: 'motor', name: 'Hauptmotor', critical: true },
      { id: 'belt1', name: 'Förderband 1' },
      { id: 'belt2', name: 'Förderband 2' },
      { id: 'belt3', name: 'Förderband 3' },
      { id: 'press', name: 'Hydraulikpresse', critical: true },
      { id: 'robot', name: 'Schweißroboter' },
      { id: 'quality', name: 'Qualitätsprüfstation' }
    ],
    sensors: {
      temperature: { min: 20, max: 85, normal: [45, 65], unit: '°C' },
      current: { min: 5, max: 250, normal: [80, 150], unit: 'A' },
      voltage: { min: 380, max: 420, normal: [395, 405], unit: 'V' },
      vibration: { min: 0, max: 15, normal: [0, 5], unit: 'mm/s' },
      pressure: { min: 50, max: 200, normal: [120, 160], unit: 'bar' },
      rpm: { min: 0, max: 3000, normal: [1500, 2200], unit: 'RPM' }
    }
  },
  WINDKRAFTANLAGE: {
    id: 'windpark_bremen_t7',
    name: 'Offshore Windpark Bremen - Turbine 7',
    type: 'wind',
    components: [
      { id: 'generator', name: 'Generator', critical: true },
      { id: 'gearbox', name: 'Getriebe', critical: true },
      { id: 'blade1', name: 'Rotorblatt 1' },
      { id: 'blade2', name: 'Rotorblatt 2' },
      { id: 'blade3', name: 'Rotorblatt 3' },
      { id: 'pitch', name: 'Pitch-System' },
      { id: 'yaw', name: 'Yaw-System' },
      { id: 'cooling', name: 'Kühlsystem' }
    ],
    sensors: {
      bearingTemp: { min: -10, max: 95, normal: [25, 55], unit: '°C' },
      generatorTemp: { min: 20, max: 110, normal: [50, 80], unit: '°C' },
      current: { min: 0, max: 800, normal: [200, 600], unit: 'A' },
      voltage: { min: 600, max: 720, normal: [680, 700], unit: 'V' },
      vibration: { min: 0, max: 30, normal: [0, 8], unit: 'mm/s' },
      windSpeed: { min: 0, max: 30, normal: [5, 15], unit: 'm/s' },
      power: { min: 0, max: 5000, normal: [2000, 4000], unit: 'kW' },
      oilPressure: { min: 1, max: 8, normal: [3, 6], unit: 'bar' }
    }
  },
  SCHIFF: {
    id: 'ms_nordic_carrier',
    name: 'MS Nordic Carrier',
    type: 'marine',
    components: [
      { id: 'engine', name: 'Hauptmaschine', critical: true },
      { id: 'gen1', name: 'Generator 1', critical: true },
      { id: 'gen2', name: 'Generator 2' },
      { id: 'cooling', name: 'Kühlwassersystem' },
      { id: 'rudder', name: 'Hydraulische Ruderanlage' },
      { id: 'ramp', name: 'Laderampen-Hydraulik' }
    ],
    sensors: {
      engineTemp: { min: 40, max: 105, normal: [70, 90], unit: '°C' },
      coolantTemp: { min: 25, max: 85, normal: [50, 70], unit: '°C' },
      oilPressure: { min: 2, max: 10, normal: [5, 7], unit: 'bar' },
      fuelPressure: { min: 50, max: 1200, normal: [800, 1000], unit: 'bar' },
      vibration: { min: 0, max: 20, normal: [0, 6], unit: 'mm/s' },
      rpm: { min: 0, max: 200, normal: [80, 150], unit: 'RPM' },
      current: { min: 100, max: 1500, normal: [400, 900], unit: 'A' }
    }
  }
};

// Status-Definitionen
export const STATUS_TYPES = {
  NORMAL: 'normal',
  WARNING: 'warning',
  CRITICAL: 'critical'
};

// Meldungen für jeden Status
export const STATUS_MESSAGES = {
  [STATUS_TYPES.NORMAL]: [
    { text: 'Alle Systeme betriebsbereit', prediction: null },
    { text: 'Keine Anomalien erkannt', prediction: null },
    { text: 'Optimale Betriebsparameter', prediction: null },
    { text: 'Normalbetrieb', prediction: null }
  ],
  [STATUS_TYPES.WARNING]: [
    { text: 'Lagertemperatur erhöht - Überwachung erforderlich', prediction: null },
    { text: 'Vibrationsanstieg erkannt - Prüfung empfohlen', prediction: null },
    { text: 'Öldruck unter Sollwert - Wartung planen', prediction: null },
    { text: 'Anomalie in Sensordaten - Analyse läuft', prediction: null },
    { text: 'Temperaturgrenzwert überschritten', prediction: null },
    { text: 'Leichte Abweichung der Betriebsparameter', prediction: null }
  ],
  [STATUS_TYPES.CRITICAL]: [
    { text: '⚠️ AUSFALL IN 10 TAGEN PROGNOSTIZIERT', prediction: { days: 10, probability: 89 } },
    { text: 'Kritische Temperatur erreicht - Sofortmaßnahme erforderlich', prediction: { days: 5, probability: 92 } },
    { text: 'Lagerdefekt wahrscheinlich - Stillstand droht', prediction: { days: 7, probability: 87 } },
    { text: 'Mehrere Parameter außerhalb Toleranz', prediction: { days: 8, probability: 85 } },
    { text: 'Sofortige Wartung erforderlich', prediction: { days: 3, probability: 94 } }
  ]
};

// Generiere Sensor-Wert basierend auf Status
export const generateSensorValue = (sensor, status) => {
  const { min, max, normal } = sensor;
  
  switch (status) {
    case STATUS_TYPES.NORMAL:
      // Im normalen Bereich
      return normal[0] + Math.random() * (normal[1] - normal[0]);
      
    case STATUS_TYPES.WARNING:
      // Leicht außerhalb des Normalbereichs
      if (Math.random() > 0.5) {
        // Über Normalbereich
        return normal[1] + Math.random() * (max - normal[1]) * 0.4;
      } else {
        // Unter Normalbereich
        return normal[0] - Math.random() * (normal[0] - min) * 0.4;
      }
      
    case STATUS_TYPES.CRITICAL:
      // Deutlich außerhalb des Normalbereichs
      if (Math.random() > 0.5) {
        // Nahe Maximum
        return normal[1] + Math.random() * (max - normal[1]) * 0.8;
      } else {
        // Nahe Minimum
        return max * 0.8 + Math.random() * max * 0.2;
      }
      
    default:
      return (min + max) / 2;
  }
};

// Generiere Daten für alle Anlagen
export const generateAssetData = (status) => {
  const data = {};
  
  // Initialisiere alle Anlagen
  Object.keys(ASSETS).forEach(assetKey => {
    const asset = ASSETS[assetKey];
    data[asset.id] = {
      ...asset,
      status,
      timestamp: new Date().toISOString(),
      readings: {},
      affectedComponents: [] // Betroffene Komponenten
    };
    
    // Generiere Sensor-Werte
    Object.keys(asset.sensors).forEach(sensorKey => {
      const sensor = asset.sensors[sensorKey];
      const value = generateSensorValue(sensor, status);
      
      data[asset.id].readings[sensorKey] = {
        value: parseFloat(value.toFixed(2)),
        unit: sensor.unit,
        status: getSensorStatus(value, sensor),
        timestamp: new Date().toISOString()
      };
    });
    
    // Füge zufällige Nachrichten hinzu
    const messagesData = getRandomMessages(status, 2);
    data[asset.id].messages = messagesData.messages;
  });
  
  // Bei Warnungen oder kritischen Status: Wähle 1-3 Komponenten aus ALLEN Anlagen
  if (status !== STATUS_TYPES.NORMAL) {
    // Sammle alle möglichen Komponenten mit Asset-Referenz
    const allComponents = [];
    Object.keys(ASSETS).forEach(assetKey => {
      const asset = ASSETS[assetKey];
      asset.components.forEach(component => {
        allComponents.push({
          assetId: asset.id,
          componentId: component.id
        });
      });
    });
    
    // Wähle 1-3 zufällige Komponenten aus dem gesamten Pool
    const numAffected = Math.floor(Math.random() * 3) + 1; // 1-3 Komponenten
    const shuffled = allComponents.sort(() => 0.5 - Math.random());
    const selectedComponents = shuffled.slice(0, numAffected);
    
    // Verteile die ausgewählten Komponenten auf die jeweiligen Anlagen
    selectedComponents.forEach(({ assetId, componentId }) => {
      if (data[assetId]) {
        data[assetId].affectedComponents.push(componentId);
      }
    });
  }
  
  return data;
};

// Bestimme Sensor-Status basierend auf Wert
const getSensorStatus = (value, sensor) => {
  const { normal, min, max } = sensor;
  
  if (value >= normal[0] && value <= normal[1]) {
    return STATUS_TYPES.NORMAL;
  } else if (value >= min && value <= max) {
    return STATUS_TYPES.WARNING;
  } else {
    return STATUS_TYPES.CRITICAL;
  }
};

// Hole zufällige Status-Nachrichten
const getRandomMessages = (status, count) => {
  const messages = STATUS_MESSAGES[status];
  const selected = [];
  
  for (let i = 0; i < count && i < messages.length; i++) {
    const randomIndex = Math.floor(Math.random() * messages.length);
    const msg = messages[randomIndex];
    if (!selected.find(s => s.text === msg.text)) {
      selected.push({
        text: msg.text,
        prediction: msg.prediction ? {
          date: new Date(Date.now() + msg.prediction.days * 24 * 60 * 60 * 1000).toISOString(),
          probability: msg.prediction.probability
        } : null
      });
    }
  }
  
  return { messages: selected };
};

// Berechne Gesamtstatus basierend auf Komponenten
export const calculateOverallStatus = (assetData) => {
  const statuses = Object.values(assetData).map(asset => asset.status);
  
  if (statuses.some(s => s === STATUS_TYPES.CRITICAL)) {
    return STATUS_TYPES.CRITICAL;
  } else if (statuses.some(s => s === STATUS_TYPES.WARNING)) {
    return STATUS_TYPES.WARNING;
  } else {
    return STATUS_TYPES.NORMAL;
  }
};

// Generiere historische Daten für Charts
export const generateHistoricalData = (sensor, status, points = 20) => {
  const data = [];
  const now = new Date();
  
  for (let i = points - 1; i >= 0; i--) {
    const timestamp = new Date(now.getTime() - i * 60000); // 1 Minute Intervalle
    const value = generateSensorValue(sensor, status);
    
    data.push({
      timestamp: timestamp.toISOString(),
      value: parseFloat(value.toFixed(2))
    });
  }
  
  return data;
};
